import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-image-view" }
const _hoisted_2 = { class: "pantry-image-view-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryImageRoomFreezerView = _resolveComponent("PantryImageRoomFreezerView")
  const _component_PantryImageRoomView = _resolveComponent("PantryImageRoomView")
  const _component_PantryImageRoomHorizontalView = _resolveComponent("PantryImageRoomHorizontalView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_PantryImageRoomFreezerView, {
        roomId: _ctx.FRIDGE_ROOM_ID_TYPE.FREEZER,
        room: _ctx.getImages(_ctx.FRIDGE_ROOM_ID_TYPE.FREEZER),
        isSelect: _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.FREEZER,
        applianceId: _ctx.applianceId,
        imageUpdate: _ctx.imageUpdate,
        cameraRoomInfo: _ctx.cameraRoomInfo,
        onSelectImage: _ctx.onSelectImage,
        onShowDate: _ctx.onShowDate
      }, null, 8, ["roomId", "room", "isSelect", "applianceId", "imageUpdate", "cameraRoomInfo", "onSelectImage", "onShowDate"]), [
        [_vShow, _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.FREEZER]
      ]),
      _withDirectives(_createVNode(_component_PantryImageRoomView, {
        roomId: _ctx.FRIDGE_ROOM_ID_TYPE.VEGETABLE,
        room: _ctx.getImages(_ctx.FRIDGE_ROOM_ID_TYPE.VEGETABLE),
        isSelect: _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.VEGETABLE,
        applianceId: _ctx.applianceId,
        imageUpdate: _ctx.imageUpdate,
        onSelectImage: _ctx.onSelectImage,
        onShowDate: _ctx.onShowDate
      }, null, 8, ["roomId", "room", "isSelect", "applianceId", "imageUpdate", "onSelectImage", "onShowDate"]), [
        [_vShow, _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.VEGETABLE]
      ]),
      _withDirectives(_createVNode(_component_PantryImageRoomView, {
        roomId: _ctx.FRIDGE_ROOM_ID_TYPE.FRIDGE,
        room: _ctx.getImages(_ctx.FRIDGE_ROOM_ID_TYPE.FRIDGE),
        isSelect: _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.FRIDGE,
        applianceId: _ctx.applianceId,
        imageUpdate: _ctx.imageUpdate,
        onSelectImage: _ctx.onSelectImage,
        onShowDate: _ctx.onShowDate
      }, null, 8, ["roomId", "room", "isSelect", "applianceId", "imageUpdate", "onSelectImage", "onShowDate"]), [
        [_vShow, _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.FRIDGE]
      ]),
      _withDirectives(_createVNode(_component_PantryImageRoomHorizontalView, {
        roomId: _ctx.FRIDGE_ROOM_ID_TYPE.DOOR,
        room: _ctx.getImages(_ctx.FRIDGE_ROOM_ID_TYPE.DOOR),
        cameraRoomInfo: _ctx.cameraRoomInfo,
        isSelect: _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.DOOR,
        applianceId: _ctx.applianceId,
        imageUpdate: _ctx.imageUpdate,
        onSelectImage: _ctx.onSelectImage,
        onShowDate: _ctx.onShowDate
      }, null, 8, ["roomId", "room", "cameraRoomInfo", "isSelect", "applianceId", "imageUpdate", "onSelectImage", "onShowDate"]), [
        [_vShow, _ctx.selectRoomId == _ctx.FRIDGE_ROOM_ID_TYPE.DOOR]
      ])
    ])
  ]))
}